import { Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import NotFound from "../pages/404/NotFound";
import AdminPrivateRouter from "./AdminPrivateRouter";
import useAuth from "../hooks/useAuth";
import { useEffect, useRef, useState } from "react";
import StorageService from "../services/storage/storage.service";
import { useAppDispatch, useAppSelector } from "../store/storeRequests";
import { getUserDetails } from "../store/authentication/authentication.actions";
import StoreSelectors from "../utils/constants/StoreSelectors.constants";
import Sidebar from "../components/Sidebar/Sidebar";
import CustomToast from "../components/CustomToast/CustomToast";
import NavigationConst from "../utils/constants/navigation.constants";
import LoginPage from "../pages/login/LoginPage";
 
const AdminRouter = () => {
  const isExecuted = useRef(false);
  const dispatch = useAppDispatch();
  const currentUser = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAppSelector(StoreSelectors.USER_STATE);
  
  useEffect(() => {
    if (isExecuted.current === false) {
      if (currentUser === 1) {
        const { user } = StorageService.getFromStorage(["user"]);
        if (typeof user?.token === "string") {
          dispatch(getUserDetails());
        } else {
          navigate("/admin/login");
        }
      }
    }
 
    isExecuted.current = true;
  }, []);
 
  // console.log("CURRENT USER",currentUser);

  // useEffect(() => {
  //   if (currentUser === 0 && !['/terms-of-use', '/privacy-policy'].includes(location.pathname)) {
  //     navigate("/admin/login");
  //   }
  // }, [user]);

  useEffect(() => {
    if (currentUser === 1 && location.pathname === "/admin/login") {
      navigate(""); // Change this to the desired home page route
    }
  }, [currentUser, location.pathname, navigate]);
 
  return (
    <>
      <div className="admin-main-container d-flex">
       
        <CustomToast />
        {(currentUser === 1 && location.pathname !== '/admin/login') && (
          <div className="left-pane-layout primary-bg-color">
            <Sidebar />
          </div>
        )}
        <Routes>
            {
              currentUser !== 1 &&
              <Route
                key={`public_1000`}
                index
                path='/admin/login'
                element={<LoginPage />}
              />
            }
 
          <Route path="" element={<AdminPrivateRouter />}>
            {NavigationConst.map(
              (nav) =>
                nav.authRequired && (
                  <Route                 
                    key={`public_${nav.id}`}
                    index={nav.indexRoute}
                    path={nav.path}
                    element={<nav.element />}
                  />
                )
            )}
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </>
  );
};
 
export default AdminRouter;
 
